import { render, staticRenderFns } from "./GiveScholarshipToMenteeModal.vue?vue&type=template&id=53982913&scoped=true&"
import script from "./GiveScholarshipToMenteeModal.vue?vue&type=script&lang=js&"
export * from "./GiveScholarshipToMenteeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53982913",
  null
  
)

export default component.exports